import React from 'react';
import {
    ReferenceManyField,
    ChipField,
    SingleFieldList,
    ArrayInput,
    SelectInput,
    NumberInput,
    List,
    Datagrid,
    Edit,
    Create,
    SimpleForm,
    TextField,
    EditButton,
    TextInput,
    required,
    SimpleList,
    Filter,
    Pagination,
    CloneButton,
    SimpleFormIterator,
    Toolbar,
    SaveButton,
    FormDataConsumer,
    useRefresh,
    BooleanInput,
    AutocompleteArrayInput,
    NumberField,
    SelectArrayInput,
    EmailField
} from 'react-admin';
import LocalBar from '@mui/icons-material/LocalBar';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import RestoreIcon from '@mui/icons-material/Restore';
import Actions from '../components/reactAdmin/Actions';
import { useMediaQuery } from '@material-ui/core';
import {dateFromObjectId, formatCurrency, formatCurrencyWithCode, getChoices, getCompleteByPaymentChoices, getHybridPaymentChoices, getHybridRefundChoices, notifyError, notifySuccess, startLoading, stopLoading} from '../util';
// import OrderedFormIterator from '../iterator/OrdererdFormIterator';
import config from "../config";
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import InputAdornment from '@material-ui/core/InputAdornment';
import { request } from '../util';
import EqualizerIcon from '@mui/icons-material/Equalizer';

import { translate } from '../i18n/customI18nProvider';

import './../css/App.css';
import ImportConsumptions from '../components/bar/ImportConsumptions';
import ImportBars from '../components/bar/ImportBars';
import { getRight, getToken } from '../services/storage';
import { testPrint } from '../services/print.service';
import ConsumptionList from './bars/ConsumptionList';
import DepositList from './bars/DepositList';
import DepositReturnList from './bars/DepositReturnList';
import TagsInput from '../components/reactAdmin/TagsInput';
import Swal from 'sweetalert2';
import { generateTableBadges } from '../screens/OrderAndPay/utils';
import Queue from '@material-ui/icons/Queue';
import ResponsiveDatagrid from '../components/reactAdmin/ResponsiveDatagrid';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { SWIPE_ANIMATIONS } from '../components/table/SwipeableRow';

export const BarIcon = LocalBar;


// Styles

const headerTextStyles = {
    width: '100%',
    borderBottom: '2px solid' + config.baseColor,
    // marginBottom: '10px',
    color: config.baseColor
};

// Styles End


const QuickFilter = ({ label }) => {
    return <Chip style={{margin: 8, marginLeft: 0}} label={translate(label)} />;
};

const BarListFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="name" variant='outlined' alwaysOn />
        <QuickFilter source="deleted_only" label={'custom.deleted_only'} defaultValue={true} />
        <QuickFilter source="with_deleted" label={'custom.with_deleted'} defaultValue={true} />
    </Filter>
);

const BarListPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;

const StatisticsButton = ({record}) => {
    return (
        <Button style={{marginLeft: '10px'}} size="small" variant="outlined" color="primary" onClick={() => {
            window.open(`/statistics/${record._id}`, '_blank');
        }}>
            <EqualizerIcon style={{marginRight: '8px'}} />
            {translate('custom.statistics')}
        </Button>
    );
};

const handleClone = async (record, refresh, showLoading = true) => {
    try {
        if (showLoading) startLoading();
        await request('/v1/bars/' + record._id + '/clone', 'POST', null, {});
        if (showLoading) stopLoading("success", translate('custom.clone_success'));
        refresh();
    } catch(e) {
        if (showLoading) stopLoading("error", e.message ? e.message : translate('custom.clone_error'));
        console.log(e.message);
    }
};

const CustomCloneButton = ({record, ...rest}) => {
    const refresh = useRefresh();

    return (
        <Button size="small" color="primary" onClick={() => handleClone(record, refresh)}>
            <Queue style={{marginRight: '8px'}} />
            {translate('custom.clone')}
        </Button>
    );
}

const CustomButtons = ({record}) => {
    const refresh = useRefresh();
    if(record.deleted) {
        return (
            <>
                <Button
                    color="primary"
                    startIcon={<RestoreIcon />}
                    onClick={async () => {
                        try {
                            await request('/bars/' + record._id + '/restore', 'POST', null, {});
                            refresh();
                        } catch(e) {
                            console.log(e.message)
                        }
                    }}
                    style={{marginLeft: '10px', marginRight: '10px'}}
                >
                    {translate('custom.restore')}
                </Button>
            </>
        )
    } else {
        return (
            <>
                <EditButton record={record} style={{marginLeft: '10px', marginRight: '10px'}} />
                <CustomCloneButton record={record} style={{marginLeft: '10px', marginRight: '10px'}} />
                <StatisticsButton record={record} />
            </>
        )
    }
}

export const BarList = (props) => {
    const history = useHistory();
    const refresh = useRefresh();

    let users_view;
    let opt;
    if(getToken() && (getRight()  >= config.permissions.ADMIN.value))
        users_view = (
            <ReferenceManyField label={translate('custom.users')} reference="users" target="bar_id" sortable={false} >
                <SingleFieldList>
                    <ChipField source="email" />
                </SingleFieldList>
            </ReferenceManyField>
        )
    else
        users_view = (
            <></>
        )

    if(getToken() && (getRight()  >= config.permissions.ADMIN.value)) {
        opt = {
            ...props
        }
    }
    else {
        opt = {
            ...props,
            hasCreate: false,
            bulkActionButtons: false
        }
    }

    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    // let isSmall = false;
    // if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    //     || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(navigator.userAgent.substr(0,4))) { 
    //     isSmall = true;
    // }
    return (

        <>

        <ImportBars />
        
        <List {...opt}
            actions={<Actions />}
            filters={<BarListFilter />}
            pagination={<BarListPagination />}
            perPage={100}
        >
            <ResponsiveDatagrid
                mobile={{
                    title: r => r.name,
                    lines: [r => (
                            <ReferenceManyField basePath="users" record={r} target="bar_id" reference="users" linkType={false}>
                                <SingleFieldList>
                                    <EmailField source="email" style={{marginRight: '10px'}} />
                                </SingleFieldList>
                            </ReferenceManyField>
                        )
                    ],
                    right: r => (dateFromObjectId(r._id)).toLocaleDateString('fr-CH'),
                }}
                onClick={(record) => { history.push('/bars/' + record._id) }}
                swipeAction={{
                    icon: <Queue />,
                    onClick: (record) => handleClone(record, refresh, false),
                    label: translate('custom.retry'),
                    animation: SWIPE_ANIMATIONS.loading
                }}
            >
                <TextField label={translate('custom.name')} source="name" />
                {users_view}
                <NumberField label={translate('custom.desired_number_of_smartphones')} source="number_of_smartphones" />
                <CustomButtons />
            </ResponsiveDatagrid>
        </List>

        </>
    );
};

const PostTitle = ({ record }) => {
    return <span>{translate('custom.point_of_sale')} {record ? `"${record.name}"` : ''}</span>;
};

const possible_deposit_returns_form = (deposits=[], currencyCode, bar_id) => {  
    return (
        <div style={{padding: '10px', border: '1px solid lightgray', borderRadius: '10px', marginTop: '20px'}}>
            <DepositReturnList deposits={deposits} currencyCode={currencyCode} bar_id={bar_id} />
        </div>
    );
}

const possible_deposits_form = (deposits = [], currencyCode = '', bar_id=null) => {    
    return (
        <div style={{padding: '10px', border: '1px solid lightgray', borderRadius: '10px', marginTop: '20px'}}>
            <DepositList deposits={deposits} currencyCode={currencyCode} bar_id={bar_id} />
        </div>
    );
}

const consumption_form = (deposits = [], max_consumption_price = 0, currencyCode = '', bar_id = null) => {
    return (
        <div style={{padding: '10px', border: '1px solid lightgray', borderRadius: '10px', marginTop: '20px'}}>
            <ConsumptionList deposits={deposits} max_consumption_price={max_consumption_price} currencyCode={currencyCode} bar_id={bar_id} />
        </div>
    );
}

const printers_form = () => {
    return (

        <Grid container style={{width: '100%'}} spacing={2}>
            <Grid item xs={12} style={{margin: '10px', border: '1px solid lightgray', borderRadius: '10px'}}>

                <div style={{width: '100%'}}>
                    <h3 style={headerTextStyles}>{translate('custom.printers')}</h3>
                </div>


                <ArrayInput source="printers" label={' '}>
                    <SimpleFormIterator>
                        <FormDataConsumer>
                            {({ getSource, scopedFormData }) => {
                                return (
                                    <>
                                        <Grid container spacing={2} style={{width: '100%'}}>
                                            <Grid item xs={12} sm={12} md={6} lg={4} xl={2}>
                                                <SelectInput fullWidth source={getSource("type")} label={translate('custom.printer_type')} validate={required()} autoFocus variant='outlined' choices={config.printer_types} record={scopedFormData} />
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6} lg={4} xl={2}>
                                                <TextInput fullWidth source={getSource("server_id")} label={translate('custom.server_id')} validate={required()} variant='outlined' record={scopedFormData} />
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6} lg={4} xl={2}>
                                                <TextInput fullWidth source={getSource("ip")} label={translate('custom.ip_address')} validate={required()} variant='outlined' record={scopedFormData} />
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6} lg={4} xl={2}>
                                                <BooleanInput fullWidth source={getSource("master")} label={translate('custom.master')} defaultValue={true} record={scopedFormData}
                                                    helperText={translate('custom.TEXT.master_printer_info_text')}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6} lg={4} xl={2}>
                                                <BooleanInput fullWidth source={getSource("each_quantity_separate_ticket")} label={translate('custom.each_quantity_separate_ticket')} defaultValue={false} record={scopedFormData}
                                                    helperText={translate('custom.TEXT.each_quantity_separate_ticket_printer_info_text')}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6} lg={4} xl={2}>
                                                <BooleanInput fullWidth source={getSource("do_not_print_cancellation_ticket")} label={translate('custom.do_not_print_cancellation_ticket')} defaultValue={false} record={scopedFormData} />
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6} lg={6} xl={2}>
                                                <Button
                                                    variant='outlined'
                                                    fullWidth
                                                    style={{marginTop: '8px'}}
                                                    onClick={async () => {
                                                        let payload = {
                                                            type: scopedFormData.type,
                                                            server_id: scopedFormData.server_id,
                                                            ip: scopedFormData.ip
                                                        };

                                                        testPrint(payload);
                                                    }}
                                                >
                                                    {translate('custom.test_print')}
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <ArrayInput source={getSource("tags")} label={translate('custom.tags')}>
                                                    <SimpleFormIterator>
                                                        <TextInput fullWidth label={translate('custom.tag')} validate={required()} variant='outlined' record={scopedFormData} />
                                                    </SimpleFormIterator>
                                                </ArrayInput>
                                            </Grid>
                                        </Grid>
                                    </>
                                );
                            }}
                        </FormDataConsumer>
                    </SimpleFormIterator>
                </ArrayInput>


            </Grid>
        </Grid>

    );
}

const ReceiptSettingsForm = ({ config }) => {
    return (        
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div style={sectionContainerStyles}>
                <div style={headerDashedTextStyles}>
                    <BooleanInput helperText={translate('custom.receipt_settings_bars')} source="receipt_settings.enabled" label={translate('custom.receipt_settings')} />
                </div>
                <FormDataConsumer subscription={{ values: true }}>
                    {({ formData }) => (
                        <Grid container style={{width: '100%'}} spacing={2}>
                            <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                                <SelectInput disabled={!formData.receipt_settings?.enabled} fullWidth={true} source="receipt_settings.mode" label={translate('custom.print_mode')} choices={getChoices(config.print_modes)} variant='outlined' />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                                <BooleanInput disabled={!formData.receipt_settings?.enabled} fullWidth={true} source="receipt_settings.print_by_tag" label={translate('custom.print_by_tag')} variant='outlined' />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                                <BooleanInput disabled={!formData.receipt_settings?.enabled} fullWidth={true} source="receipt_settings.print_double" label={translate('custom.print_double')} variant='outlined' />
                            </Grid>
                        </Grid>
                    )}
                </FormDataConsumer>
            </div>
        </Grid>
    )
}

class BarDetailsForm extends React.Component {

    constructor(props) {
        super(props);

        let table_numbers = props.record?.table_numbers || [];
        table_numbers = table_numbers.map((table_number) => {
            return {id: table_number, name: table_number};
        })

        this.state = {
            table_numbers: table_numbers,
            deposits: []
        }
    }

    async componentDidMount() {
        let deposits = await request('/v1/deposits', 'GET', null);
        if(deposits.error) {
            alert(deposits.error);
        } else {
            this.setState({deposits: deposits});
        }
    }

    openOrderAndPayPage = async () => {
        let table_numbers = this.props.record.table_numbers;
        const payload = [];
        let response = await request('/v1/bars/' + this.props.record._id + '/order_and_pay_user', 'GET', null);
        if(!response.user) {
            notifyError(translate('custom.order_and_pay_user_not_found'));
            return;
        }
        const order_and_pay_user = response.user;
        window.open('/onp/' + order_and_pay_user._id + '/' + table_numbers[0], '_blank');
    }

    printQrCodes = async () => {
        let table_numbers = this.props.record.table_numbers;
        const payload = [];
        let response = await request('/v1/bars/' + this.props.record._id + '/order_and_pay_user', 'GET', null);
        if(!response.user) {
            notifyError(translate('custom.order_and_pay_user_not_found'));
            return;
        }
        const order_and_pay_user = response.user;
        for(const table_number of table_numbers) {
            payload.push({
                tableNumber: table_number,
                qrValue: `https://jmco.ch/onp/${order_and_pay_user._id}/${table_number}`
            })
        }
        generateTableBadges(payload, response.event_name, this.props.record.name)
    }


    render() {

        return (
            <Grid container spacing={2} style={{width: '100%'}}>
                <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                    <TextInput fullWidth source="name" label={translate('custom.name')} validate={required()} autoFocus variant='outlined'
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                let add_button = document.getElementsByClassName('button-add')[0];
                                add_button.click();
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                    <NumberInput fullWidth source="number_of_smartphones" label={translate('custom.desired_number_of_smartphones')} variant='outlined'
                        // disable scroll
                        onWheel={(e) => e.target.blur()}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                    <TextInput fullWidth source="order_number_prefix" label={translate('custom.order_number_prefix')} variant='outlined' defaultValue={''} />
                </Grid>
                {                    
                    (getToken() && (getRight()  >= config.permissions.ADMIN.value)) ? 
                        <>
                            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                                <div style={sectionContainerStyles}>
                                    <div style={headerDashedTextStyles}>
                                        <BooleanInput fullWidth source="enable_table_service" label={translate('custom.enable_table_service')} defaultValue={false} />
                                    </div>
                                    <TagsInput fullWidth source="table_numbers" label={translate('custom.table_numbers')} variant='outlined' />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                                <div style={sectionContainerStyles}>
                                    <div style={headerDashedTextStyles}>
                                        <BooleanInput helperText={translate('custom.restrict_payment_methods_description')} source="hybrid_payment.enabled" label={translate('custom.hybrid_payment')} />
                                    </div>
                                    <SelectArrayInput fullWidth={true} source="hybrid_payment.payment_types" label={translate('custom.hybrid_payment_types')} choices={getHybridPaymentChoices()} variant='outlined' />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                                <div style={sectionContainerStyles}>
                                    <div style={headerDashedTextStyles}>
                                        <BooleanInput source="hybrid_refund.enabled" label={translate('custom.hybrid_refund')} />
                                    </div>
                                    <SelectArrayInput fullWidth={true} source="hybrid_refund.refund_methods" label={translate('custom.hybrid_refund_methods')} choices={getHybridRefundChoices()} variant='outlined' />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                                <div style={sectionContainerStyles}>
                                    <div style={headerDashedTextStyles}>
                                        <BooleanInput helperText={translate('custom.restrict_payment_methods_description')} source="complete_by.enabled" label={translate('custom.complete_by')} />
                                    </div>
                                    <SelectArrayInput fullWidth={true} source="complete_by.payment_types" label={translate('custom.payment_types')} choices={getCompleteByPaymentChoices()} variant='outlined' />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                                <div style={sectionContainerStyles}>
                                    <div style={headerDashedTextStyles}>
                                        <BooleanInput helperText={translate('custom.order_and_pay_description')} source="order_and_pay.enabled" label={translate('custom.order_and_pay')} />
                                    </div>
                                    <div style={{display: 'flex', gap: '8px'}}>
                                        <Button variant='outlined' color='primary' fullWidth style={{marginTop: '8px'}} onClick={this.printQrCodes}>
                                            {translate('custom.show_qr_codes')}
                                        </Button>
                                        <Button variant='outlined' color='primary' fullWidth style={{marginTop: '8px'}} onClick={this.openOrderAndPayPage}>
                                            {translate('custom.open_order_and_pay_page')}
                                        </Button>                            
                                    </div>
                                </div>
                            </Grid>
                        </>
                    : <></>
                }

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <TextInput fullWidth source="info_text" label={translate('custom.additional_info_text')} variant='outlined'
                        multiline={true}
                        // rows
                        InputProps={{
                            rows: 4
                        }}
                    />
                </Grid>
                
                {                    
                    (getToken() && (getRight()  >= config.permissions.ADMIN.value)) ? 
                        <>
                            <ReceiptSettingsForm config={config} />
                        </>
                    : <></>
                }
            </Grid>
        )

    }

}

const validateBarsForm = (values, bars = []) => {

    let errors = {};

    if(('_id' in values || 'id' in values) && 'name' in values) {
        // Updating existing bar
        bars.find((bar) => {
            if(bar.name === values.name && (bar._id !== values._id || bar.id !== values.id)) {
                errors['name'] = translate('custom.this_name_is_already_taken');
            }
        })
    } else if ('name' in values) {
        // New Bar Creation
        bars.find((bar) => {
            if(bar.name === values.name) {
                errors['name'] = translate('custom.this_name_is_already_taken');
            }
        })
    }

    if(values['consumptions']) {
        for(let i=0; i<values['consumptions'].length; i++) {
            const consumption = values['consumptions'][i];
            let filtered = values['consumptions'].filter(c => c?.name === consumption?.name);
            if(filtered.length > 1) {
                if(!('consumptions' in errors)) {
                    errors['consumptions'] = [];
                }
                if(!(errors['consumptions'][i])) {
                    errors['consumptions'][i] = {};
                }
                errors['consumptions'][i]['name'] = translate('custom.this_name_is_already_taken');
            }
        }
    }

    if(values.order_and_pay?.enabled) {
        if(!values.table_numbers || values.table_numbers.length == 0) {
            errors['order_and_pay'] = {enabled: translate('custom.order_and_pay_description')};
        }
    }

    return errors
}


export class BarEdit extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            max_consumption_price: 0,
            currencyCode: '',
            deposits: [],
            bars: [],
            isLoaded: false,
            barId: props.id,
            key: Date.now()
        }
    }

    handleSuccess = () => {
        this.setState({key: Date.now()});
        Swal.fire({
            toast: true,
            position: 'bottom',
            icon: 'success',
            title: translate('custom.saved'),
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true
        });
    };



    async componentDidMount() {
        let general_information = await request('/events/general', 'GET', null);
        if(general_information.error) {
            alert(general_information.error_code ? translate('custom.' + general_information.error_code) : general_information.error);
        } else {
            this.setState({max_consumption_price: general_information.maxConsumptionPrice, currencyCode: general_information.currencyCode});
        }

        let deposits = await request('/v1/deposits', 'GET', null);
        if(deposits.error) {
            alert(deposits.error);
        } else {
            this.setState({ deposits });
        }

        let bars = await request('/bars', 'GET', null);
        bars = bars ? bars : [];

        this.setState({ 
            bars,
            isLoaded: true
        });
    }

    render() {
        return (
            <>
                <Edit key={this.state.key} mutationMode="pessimistic" onSuccess={this.handleSuccess} title={<PostTitle />} {...this.props} >
                    <SimpleForm variant="standard" redirect={'edit'} warnWhenUnsavedChanges validate={(values) => validateBarsForm(values, this.state.bars) } submitOnEnter={false}>
                        
                        <BarDetailsForm />

                        {/* hr */}
                        <div style={{width: '100%', height: '1px', backgroundColor: 'lightgray', marginTop: '20px', marginBottom: '10px'}}></div>

                        {(this.state.isLoaded && (getToken() && (getRight()  >= config.permissions.ADMIN.value))) && (
                            <>
                                {printers_form()}
                            </>
                        )}

                    </SimpleForm>
                </Edit>
                {this.state.isLoaded ? (
                    <div style={{marginBottom: '100px'}}>
                        {possible_deposit_returns_form(this.state.deposits, this.state.currencyCode, this.state.barId)}

                        {possible_deposits_form(this.state.deposits, this.state.currencyCode, this.state.barId)}

                        {consumption_form(this.state.deposits, this.state.max_consumption_price, this.state.currencyCode, this.state.barId)}
                    </div>
                ) : null}
            </>
        );
    }
}

const SaveAndAddNewToolbar = (props) => {
    const refresh = useRefresh();
    return (
        <Toolbar>
            <SaveButton
                {...props}
                label="ra.action.save"
                redirect="edit"
                style={{marginRight: 10}}
            />
            <SaveButton
                {...props}
                label={translate('custom.save_and_add')}
                redirect={() => {
                    refresh();
                    return 'create';
                }}
            />
        </Toolbar>
    )
}

export class BarCreate extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            max_consumption_price: 0,
            currencyCode: '',
            bars: [],
        }
    }

    async componentDidMount() {
        let general_information = await request('/events/general', 'GET', null);
        if(general_information.error) {
            alert(general_information.error_code ? translate('custom.' + general_information.error_code) : general_information.error);
        } else {
            this.setState({max_consumption_price: general_information.maxConsumptionPrice, currencyCode: general_information.currencyCode});
        }

        let deposits = await request('/v1/deposits', 'GET', null);
        if(deposits.error) {
            alert(deposits.error);
        } else {
            this.setState({deposits: deposits});
        }

        let bars = await request('/bars', 'GET', null);
        bars = bars ? bars : [];

        this.setState({ bars })
    }

    render() {
        let bar_create_view;
        if(getToken() && (getRight()  >= config.permissions.ADMIN.value))
            bar_create_view = (
                <Create title={translate('custom.create_point_of_sale')} {...this.props}>
                    <SimpleForm variant="standard" warnWhenUnsavedChanges validate={(values) => validateBarsForm(values, this.state.bars)}
                        toolbar={<SaveAndAddNewToolbar />}
                        submitOnEnter={false}
                        initialValues={{
                            complete_by: {
                                enabled: true,
                                payment_types: [config.payment_types.TWINT.value, config.payment_types.TWINT_DIRECT.value, config.payment_types.POS_PHONE.value],
                            }
                        }}
                    >
                        
                        <BarDetailsForm />

                        {printers_form()}
                    
                    </SimpleForm>
                </Create>
            )
        else
            bar_create_view = (
                <></>
            )

        return (bar_create_view)
    }
}

const headerDashedTextStyles = {
    width: '100%',
    borderBottom: '2px dashed' + config.baseColor,
    marginBottom: '20px',
    color: config.baseColor,
}

const sectionContainerStyles = {
    border: '2px solid' + config.baseColor,
    borderRadius: '10px',
    height: '100%',
    paddingLeft: '10px',
    paddingRight: '10px',
}
